import {  useCallback, useState } from 'react'
import { flatten } from 'shared/util'
import { Button } from '@mui/material'
import { TrushIcon } from 'shared/icons'
import { FileResponse } from "shared/api"

import { FormDialog } from 'components/dialog/form'
import { ConfirmDialog } from 'components/dialog/confirm'

import { ManufacturerResult, useEditManufacturer, useDeleteManufacturer } from "interface/manufacturer"
import { useManufacturerForm, ManufacturerForm } from "../form"

type EditManufacturerDialogProps = {
  manufacturer: ManufacturerResult
  onClose: () => void
	onEditManufacturer: (result: ManufacturerResult, logo?: FileResponse) => void
  onDeleteManufacturer: (manufacturerId: number) => void
}
export const EditManufacturerDialog = ({
  manufacturer,
  onClose,
  onEditManufacturer,
  onDeleteManufacturer
}: EditManufacturerDialogProps) => {
	const [modal, setModal] = useState<"deleteManufacturer" | "deleteExistManufacturer" | null>(null)

  const onEditted = useCallback(
    (result: ManufacturerResult) => {
      onEditManufacturer(result)
      onClose()
    },
    [onEditManufacturer, onClose]
  )
  const [editManufacturerState, editManufacturer] = useEditManufacturer(manufacturer.manufacturerId, { onEditted })
  const form = useManufacturerForm({ manufacturer, onSubmit: editManufacturer })

  const onDeleted = useCallback(
    (removedId: number) => {
      onDeleteManufacturer(removedId)
      onClose()
    },
    [onDeleteManufacturer, onClose]
  )
  const onExistSearch = useCallback(
    () => {
      setModal("deleteExistManufacturer")
    },
    [setModal]
  )
  const [deleteManufacturerState, deleteManufacturer] = useDeleteManufacturer({ onDeleted, onExistSearch })

  return (
    <FormDialog
      open
      fullWidth
      maxWidth="md"
      title="製薬企業情報を編集"
      isLoading={editManufacturerState.posting}
      error={flatten([
        editManufacturerState.error,
        deleteManufacturerState.error
      ])}
      body={<ManufacturerForm {...form}/>}
      leftAction={
        <Button
          variant="contained"
          color="error"
          size="large"
          startIcon={<TrushIcon/>}
          onClick={() => setModal("deleteManufacturer")}
        >
          削除
        </Button>
      }
      submitLabel="保存"
      isValid={form.formState.isValid}
      onSubmit={form.submit}
      onClose={onClose}
    >
      {(modal === 'deleteManufacturer') ? (
        <ConfirmDialog
          isLoading={deleteManufacturerState.posting}
          message={`${manufacturer.manufacturerName} を削除します。よろしいですか？`}
          ok={{
            label: 'はい',
            onClick: () => deleteManufacturer({
              manufacturerId: manufacturer.manufacturerId,
              checkExistSearch: true
            })
          }}
          cancel={{
            label: 'いいえ',
            onClick: () => setModal(null)
          }}
        />
      ) : (modal === 'deleteExistManufacturer') ? (
        <ConfirmDialog
          isLoading={deleteManufacturerState.posting}
          message={"使用している分析依頼が存在します。本当に削除しますか？"}
          ok={{
            label: 'はい',
            onClick: () => deleteManufacturer({
              manufacturerId: manufacturer.manufacturerId,
              checkExistSearch: false
            })
          }}
          cancel={{
            label: 'いいえ',
            onClick: () => setModal(null)
          }}
        />
      ) : <></>}
    </FormDialog>
  )
}
